import { render, staticRenderFns } from "./TransliterationBox.vue?vue&type=template&id=2fa095f6&scoped=true"
import script from "./TransliterationBox.vue?vue&type=script&lang=js"
export * from "./TransliterationBox.vue?vue&type=script&lang=js"
import style0 from "./TransliterationBox.vue?vue&type=style&index=0&id=2fa095f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa095f6",
  null
  
)

export default component.exports